export default __webpack_public_path__ + "static/banner-5-8e6906eaaf428cb2af17ce4b282eaafb.jpg";